// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"Dropdowns_dropdownContainer__VYp74","dropdownBox":"Dropdowns_dropdownBox__yjjK4","spicialties":"Dropdowns_spicialties__X5bWG"};